'use strict';

var y = require('yup');

function _interopNamespaceCompat(e) {
  if (e && typeof e === 'object' && 'default' in e) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var y__namespace = /*#__PURE__*/_interopNamespaceCompat(y);

const name = 'aptos';
const APTOS_ERROR = 'aptos';
y__namespace.addMethod(y__namespace.StringSchema, name, function(options) {
    return this.test({
        name,
        message: {
            key: options?.error ?? APTOS_ERROR
        },
        test: (value)=>{
            // Matches API requirements: https://github.com/circlefin/crypto-client/blob/4c85a7606032e3c858126dbcc3d59c4a6c449a0e/crypto/src/main/java/com/circle/crypto/utils/BlockchainConstants.java#L28
            return Boolean(RegExp(/^(0x)[0-9a-fA-F]{64}$/).exec(String(value)));
        }
    });
});

exports.APTOS_ERROR = APTOS_ERROR;
//# sourceMappingURL=aptos.js.map
